const r = {
    success: "input-success",
    error: "input-error"
};

export { r as INPUT_VARIANT_CLASSES };
//# sourceMappingURL=index.js.map
